import { render, staticRenderFns } from "./PricingDetailsCard.vue?vue&type=template&id=20e6bc68"
import script from "./PricingDetailsCard.vue?vue&type=script&lang=ts"
export * from "./PricingDetailsCard.vue?vue&type=script&lang=ts"
import style0 from "./PricingDetailsCard.vue?vue&type=style&index=0&id=20e6bc68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports